export default "/_next/static/62c0dc05aa3b13e685a49979119387ad.png";